import { Bubble, Link } from '@lt/components';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    font-family: 'Backpack', serif;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const StyledBubble = styled(Bubble)`
  font-family: 'Backpack', serif;
`;

export const Title = styled.div`
  font-family: 'Backpack', serif;
`;

export const Text = styled.div`
  font-family: 'Backpack', serif;
`;
